export default __webpack_public_path__ + "static/media/2103.d67f330f.png";